import React from 'react';
import { Link } from 'react-router-dom';
import { NavMenu } from '../navMenu/NavMenu';
import './managementDashboard.css'

export function ManagementDashboard() {
    return (
        <div className="management-dashboard">
            <div className="container">
                <NavMenu />
                <div className="buttons row">
                    <div className="col-md-3 col-6">
                      <Link to="/management/illustrations">
                          <button className="dashboard-btn illustration-btn">
                            <span>Illustration</span>
                          </button>
                      </Link>
                    </div>
                    <div className="col-md-3 col-6">
                        <Link to="/management/about">
                         <button className="dashboard-btn about-btn">
                           <span>About</span>
                         </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
